export const MODULE_ID = 'information';
